import { useState, useEffect } from 'react';
import cssVars from '../components/Grid/_variables.scss.js';

var useBreakpoint = function useBreakpoint(breakpointName, defaultMatches) {
  if (defaultMatches === void 0) {
    defaultMatches = true;
  }

  var _a = useState(defaultMatches),
      matches = _a[0],
      setMatches = _a[1];

  useEffect(function () {
    var breakpointSize = cssVars["breakpoint-" + breakpointName.toLowerCase()];
    var mediaQueryFeature = "(min-width: " + breakpointSize + ")";
    var mediaQueryList = window.matchMedia(mediaQueryFeature);

    var listener = function listener() {
      if (mediaQueryList.matches) {
        setMatches(true);
      } else {
        setMatches(false);
      }
    };

    mediaQueryList.addListener(listener);
    setMatches(mediaQueryList.matches);
    return function () {
      return mediaQueryList.removeListener(listener);
    };
  }, [breakpointName]);
  return matches;
};

export default useBreakpoint;
//# sourceMappingURL=useBreakpoint.js.map
